// extracted by mini-css-extract-plugin
export default {"buttonYesNo":"popup_buttonYesNo__t+oi1"};